import { Injectable } from '@angular/core';
import { DigitaloceanOauthTokenRes } from 'cms-typescript-sdk/digitalocean/models';

@Injectable()
export class TokenService {

  private _cahchedAuth: DigitaloceanOauthTokenRes;

  public set authInfo(authInfo: DigitaloceanOauthTokenRes) {
    this._cahchedAuth = authInfo;
    window.localStorage.setItem('auth', btoa(JSON.stringify(authInfo)));
  }

  public get authInfo(): DigitaloceanOauthTokenRes {
    if (this._cahchedAuth !== undefined) {
      return this._cahchedAuth;
    }

    if (!localStorage.getItem('auth')) {
      return undefined;
    }

    try {
      const _raw = localStorage.getItem('auth');
      return JSON.parse(atob(_raw));
    } catch (err) {
      console.error(err);
      return undefined;
    }
  }

  public get isTokenExpired(): boolean {
    return this.authInfo && +this.authInfo.expires_in * 1000 <= Date.now();
  }

  public revoke(): Promise<void> {
    window.localStorage.removeItem('auth');
    return Promise.resolve();
  }
}

